import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueMui, rydeColors } from "@ryde/theme";

/** Draggable vertex handle — white circle with a blue ring (matches the Leaflet geoman `.marker-icon`). */
export const MapLibreEditVertexStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-edit-vertex",
})<{ $deletable: boolean }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  box-sizing: border-box;
  background: ${rydeColors.white};
  border: 1px solid ${blueMui._700};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  cursor: ${({ $deletable }) => ($deletable ? "pointer" : "move")};
`;

/** Faded "add a point" handle at each segment midpoint (Leaflet geoman `.marker-icon-middle`). */
export const MapLibreEditMidpointStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "maplibre-edit-midpoint",
})`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  box-sizing: border-box;
  background: ${rydeColors.white};
  border: 1px solid ${blueMui._700};
  opacity: 0.7;
  cursor: cell;
`;
